<script setup lang="ts">
  import audioDoubleFile from '@/assets/imgs/mavelmachine/marvelAudio/double-audio.mp4'
  import { default as audioTabShortFile } from '@/assets/imgs/mavelmachine/marvelAudio/tab-audio-short.mp4'
  import audioTabLongFile from '@/assets/imgs/mavelmachine/marvelAudio/tab-audio.mp4'
  import audioTabLongFile2 from '@/assets/imgs/mavelmachine/marvelAudio/tab-audio2.mp4'
  import { useMMStore } from '@/store/MarvelMachine'
  const mmStore = useMMStore()
  let audioTabWithAnimationHistory = 0
  let audioTabWithAnimationHistoryBeingUpdated = false
  const audioTabWithAnimation = [new Audio(audioTabLongFile), new Audio(audioTabLongFile2)]
  const audioTabShort = new Audio(audioTabShortFile)

  const audioDoubleTab = new Audio(audioDoubleFile)
  const audios = [audioTabWithAnimation[0], audioTabWithAnimation[1], audioTabShort, audioDoubleTab]
  function defaultAudioSetting() {
    audios[0].playbackRate = 1.1
    audios[1].playbackRate = 1.1
    for (const audio of audios) {
      audio.volume = 0.4
      audio.loop = false
    }
  }
  onMounted(() => {
    defaultAudioSetting()
    // setTimeout(() => {
    //   mmStore.game.revealItemsAnimation = true
    // }, 1000)
    // setTimeout(() => {
    //   mmStore.game = { ...mmStore.game, ...{ resultOn: true, revealItemsAnimation: false, isSpinRunning: false } }
    // }, 8500)
  })

  watchEffect(() => {
    if (mmStore.game.revealItemsAnimation === true) {
      if (mmStore.game.animationToggle) {
        if (audioTabWithAnimationHistoryBeingUpdated === false) {
          audioTabWithAnimationHistoryBeingUpdated = true
          audioTabWithAnimation[audioTabWithAnimationHistory].play()
          setTimeout(() => {
            audioTabWithAnimationHistory = audioTabWithAnimationHistory === 0 ? 1 : 0
            audioTabWithAnimationHistoryBeingUpdated = false
            console.log('audioTabWithAnimationHistory :', audioTabWithAnimationHistory)
          }, 3500)
        }
      } else {
        setTimeout(() => {
          audioTabShort.play()
        }, 400)
      }
      // Used two different object of same sound to fix Sound Effecct Sync issue.
    }
    if (mmStore.game.doubleResultOn) {
      audioDoubleTab.play()
    }
  })
</script>

<template>
  <div class="mavel-machine-robot">
    <div
      class="mavel-machine-robot__main-jar-animation"
      :class="{
        active: mmStore.game.animationToggle && mmStore.game.revealItemsAnimation,
      }"
    ></div>
    <div
      class="mavel-machine-robot__capsules"
      :class="{
        animationOn: mmStore.game.animationToggle && mmStore.game.revealItemsAnimation,
        animationReduced: !mmStore.game.animationToggle && mmStore.game.revealItemsAnimation,
        resultOn: mmStore.game.resultOn,
        gameResetting: mmStore.game.isGameBeingResetted,
      }"
    >
      <div
        v-for="(resultItem, index) in mmStore.game.resultItems"
        :key="resultItem.couponCode"
        :class="`mavel-machine-items-animation___capsule-image mavel-machine-items-animation___capsule-image--${
          index + 1
        }`"
        :style="{
          backgroundImage: `url('https://nxcache.nexon.net/maplestory/shop/gachapon/img/items/${resultItem.itemImageName}.png')`,
        }"
      ></div>
    </div>
    <div class="mavel-machine-robot__main-top-gear"></div>
    <div class="mavel-machine-robot__main-logo"></div>
    <div class="mavel-machine-robot__main-jar"></div>
    <div class="mavel-machine-robot__main-base"></div>
    <div
      class="mavel-machine-robot__main-face"
      :class="{
        spinning: mmStore.game.isSpinRunning,
        resultOn: mmStore.game.resultOn,
      }"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
  %absolute-center {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .mavel-machine-robot__main-top-gear {
    @extend %absolute-center;
    width: calc(90px * var(--marvel-desktopRatio));
    height: calc(76px * var(--marvel-desktopRatio));
    top: calc(10px * var(--marvel-desktopRatio));
    background: url('@/assets/imgs/mavelmachine/marvelMachineRobot/main/mm-top-gear.png') no-repeat center center / 100%
      auto;
    z-index: 0;
  }
  .mavel-machine-robot__main-logo {
    @extend %absolute-center;
    width: calc(319px * var(--marvel-desktopRatio));
    height: calc(118px * var(--marvel-desktopRatio));
    top: calc(60px * var(--marvel-desktopRatio));
    background: url('@/assets/imgs/mavelmachine/marvelMachineRobot/main/logo-animated.png') no-repeat center center /
      100% auto;
    z-index: 2;
  }

  .mavel-machine-robot__main-base {
    @extend %absolute-center;
    background: url('@/assets/imgs/mavelmachine/marvelMachineRobot/main/mm-base.png') no-repeat center bottom / 100%
      auto;
    width: calc(654px * var(--marvel-desktopRatio));
    height: calc(429px * var(--marvel-desktopRatio));
    top: calc(348px * var(--marvel-desktopRatio));
    z-index: 3;
  }
  %main-jar {
    @extend %absolute-center;
    top: calc(61px * var(--marvel-desktopRatio));
    width: calc(458px * var(--marvel-desktopRatio));
    height: calc(443px * var(--marvel-desktopRatio));
  }
  .mavel-machine-robot__main-jar {
    @extend %main-jar;
    background: url('@/assets/imgs/mavelmachine/marvelMachineRobot/main/mm-jar.png') no-repeat center bottom / 100% auto;
  }
  .mavel-machine-robot__main-face {
    @extend %absolute-center;
    background: url('@/assets/imgs/mavelmachine/marvelMachineRobot/face/game-rest.png') no-repeat center bottom / 100%
      auto;
    top: calc(439px * var(--marvel-desktopRatio));
    width: calc(242px * var(--marvel-desktopRatio));
    height: calc(84px * var(--marvel-desktopRatio));
    transition: background 0.2s;
    z-index: 4;
    &.spinning {
      background-image: url('@/assets/imgs/mavelmachine/marvelMachineRobot/face/game-spinning.png');
    }
    &.resultOn {
      background-image: url('@/assets/imgs/mavelmachine/marvelMachineRobot/face/game-result-on.png');
    }
  }
  .mavel-machine-robot__main-jar-animation {
    @extend %main-jar;
    background: url('@/assets/imgs/mavelmachine/marvelMachineRobot/items/item-reveal-jar.png') no-repeat 0 0;
    transition: opacity 0.2s;
    background-size: 4000%;
    z-index: 1;
    opacity: 0;
    &.active {
      opacity: 1;
      /* animation: mavel-machine-robot__reveal-items 5s steps(39);  */
      animation: mavel-machine-robot__reveal-items 4s steps(39);
    }
  }
  @keyframes mavel-machine-robot__reveal-items {
    100% {
      background-position: 100% 0;
    }
  }

  .mavel-machine-robot__capsules {
    @extend %absolute-center;
    width: calc(543px * var(--marvel-desktopRatio));
    height: calc(259px * var(--marvel-desktopRatio));
    top: calc(540px * var(--marvel-desktopRatio));
    transition: opacity 0.3s;
    z-index: 5;
    /* animation-delay: 1s; */
    &.animationOn {
      background: url('@/assets/imgs/mavelmachine/marvelMachineRobot/items/item-reveal-ball.png') no-repeat;
      background-position: 0 0;
      background-size: 2300%;
      opacity: 1;
      /* animation: mavel-machine-robot__capsules 2.8s steps(22) forwards; */
      animation: mavel-machine-robot__capsules 2.3s steps(22) forwards;
      animation-delay: 4s;
      @keyframes mavel-machine-items-animation___capsule-image {
        0% {
          opacity: 0;
          transform: rotate(0deg);
        }
        100% {
          opacity: 0.5;
          transform: rotate(360deg);
        }
      }
      @keyframes itemMoving {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
      .mavel-machine-items-animation___capsule-image--1 {
        animation: mavel-machine-items-animation___capsule-image 0.8s forwards 5.5s;
      }
      .mavel-machine-items-animation___capsule-image--2 {
        animation: mavel-machine-items-animation___capsule-image 0.8s forwards 6s;
      }
      .mavel-machine-items-animation___capsule-image--3 {
        animation: mavel-machine-items-animation___capsule-image 0.8s forwards 5s;
      }
    }
    &.animationReduced,
    &:after {
      content: '';
      background: url('@/assets/imgs/mavelmachine/marvelMachineRobot/items/item-reveal-ball-reduced.png') no-repeat
        center top / 140% auto;
    }
    &.resultOn,
    &:before {
      content: '';
      background: url('@/assets/imgs/mavelmachine/marvelMachineRobot/items/item-revealed-empty-capsules.png') no-repeat
        center 3px / 100% auto;
    }
    &.resultOn {
      .mavel-machine-items-animation___capsule-image {
        opacity: 0.5;
      }
    }
    &.gameResetting {
      opacity: 0;
    }
  }
  .mavel-machine-items-animation___capsule-image {
    position: absolute;
    top: calc(80px * var(--marvel-desktopRatio));
    width: calc(40px * var(--marvel-desktopRatio));
    height: calc(40px * var(--marvel-desktopRatio));
    background: no-repeat center center / 100% 100%;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .mavel-machine-items-animation___capsule-image--1 {
    left: 20.5%;
    animation: itemMoving 11s infinite;
    animation-delay: 0.1s;
  }

  .mavel-machine-items-animation___capsule-image--2 {
    left: 47.5%;
    animation: itemMoving 11.1s infinite;
    animation-delay: 0.3s;
  }

  .mavel-machine-items-animation___capsule-image--3 {
    left: 72.5%;
    animation: itemMoving 11.3s infinite;
    animation-delay: 0.5s;
  }

  @keyframes mavel-machine-robot__capsules {
    100% {
      background-position: 100% 0;
    }
  }

  /* @media #{$tabletForMarvel} {
  .mavel-machine-robot__main-top-gear {
    width: 8vw;
    height: 8vw;
    top: 0.8vw;
  }
  .mavel-machine-robot__main-logo {
    width: 36vw;
    height: 13vw;
    top: 7vw;
  }

  .mavel-machine-robot__main-base {
    width: 73vw;
    height: 52vw;
    top: 35vw;
  }
  .mavel-machine-robot__main-jar,
  .mavel-machine-robot__main-jar-animation {
    width: 52.5vw;
    height: 51vw;
    top: 6vw;
  }
  .mavel-machine-robot__main-face {
    width: 27vw;
    height: 9.3vw;
    top: 49.2vw;
  }
  .mavel-machine-robot__capsules {
    width: 60vw;
    height: 24vw;
    top: 60.7vw;
  }
  .mavel-machine-items-animation___capsule-image {
    top: 8.6vw;
    width: 4.5vw;
    height: 4.5vw;
  }
  .mavel-machine-items-animation___capsule-image--1 {
    left: 20.5%;
  }
} */

  @media #{$mobileForMarvel} {
    .mavel-machine-robot__main-top-gear {
      width: 11vw;
      height: 9vw;
      top: 1.2vw;
    }
    .mavel-machine-robot__main-logo {
      width: 42vw;
      height: 16vw;
      top: 10vw;
    }

    .mavel-machine-robot__main-base {
      width: 91vw;
      height: 66vw;
      top: 43vw;
    }
    .mavel-machine-robot__main-jar,
    .mavel-machine-robot__main-jar-animation {
      width: 65.5vw;
      height: 64vw;
      top: 7vw;
    }
    .mavel-machine-robot__main-face {
      width: 33vw;
      height: 10vw;
      top: 64vw;
    }
    .mavel-machine-robot__capsules {
      width: 75.3vw;
      height: 32vw;
      top: 76vw;
    }
    .mavel-machine-items-animation___capsule-image {
      top: 11vw;
      width: 5vw;
      height: 5vw;
    }
    .mavel-machine-items-animation___capsule-image--1 {
      left: 21%;
    }
  }
</style>
